module.exports = __webpack_public_path__ + "static/media/p3.ae5960fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p3.png
// module id = 957
// module chunks = 0